const _width = Symbol('width');
const _height = Symbol('height');
const _container = Symbol('container');

export class ChartCanvas {
    constructor (container) {
        this[_container] = container;
        this[_width] = 0;
        this[_height] = 0;
        Object.preventExtensions(this);
    }

    get container () {
        return this[_container];
    }

    get width () {
        return this[_width];
    }

    get height () {
        return this[_height];
    }

    resize (width, height) {
        this[_width] = width;
        this[_height] = height;
    }
}
